export default {
  data() {
    return {
      listTypeInfo: {
        // 未申请、初审中、复审中、审核拒绝、审核通过
        auditStatusList: [
          {
            name: '全部',
            id: '',
          },
          {
            name: '未申请',
            id: '0',
          },
          {
            name: '初审中',
            id: '1',
          },
          {
            name: '复审中',
            id: '2',
          },
          {
            name: '审核拒绝',
            id: '3,5',
          },
          {
            name: '审核通过',
            id: '2,4',
          },
        ],
        filingStatusList: [
          {
            name: '全部',
            id: '',
          },
          {
            name: '已备案',
            id: 2,
          },
          {
            name: '未备案',
            id: 0,
          },
          {
            name: '公示中',
            id: 1,
          },
        ],
        orgSettingList: [
          {
            name: '全部',
            id: '',
          },
          {
            name: '否',
            id: 0,
          },
          {
            name: '是',
            id: 1,
          },
        ],
        openEpecPurchaseList: [
          {
            name: '全部',
            id: '',
          },
          {
            name: '否',
            id: 0,
          },
          {
            name: '是',
            id: 1,
          },
        ],
        corporateCreditGradeList: [
          {
            name: '全部',
            id: '',
          },
          {
            name: '否',
            id: 0,
          },
          {
            name: '是',
            id: 1,
          },
        ],
      },
    };
  },
  methods: {
    getOrgSetting(orgSetting) {
      const { name = '' } =
        this.listTypeInfo.orgSettingList.find(
          (item) => item.id === orgSetting
        ) || {};
      return name;
    },
    getOpenEpecPurchase(openEpecPurchase) {
      const { name = '' } =
        this.listTypeInfo.openEpecPurchaseList.find(
          (item) => item.id === openEpecPurchase
        ) || {};
      return name;
    },
    getCorporateCreditGrade(corporateCreditGrade) {
      const { name = '' } =
        this.listTypeInfo.corporateCreditGradeList.find(
          (item) => item.id === corporateCreditGrade
        ) || {};
      return name;
    },
  },
};
